export const NO_PLUG = 'NoPlug';
export const CCS1 = 'CCS1';
export const CCS2 = 'CCS2';
export const CHADEMO = 'CHAdeMO';
export const TESLA = 'Tesla';
export const GBTDC = 'GB/T DC';
export const GBTAC = 'GB/T AC';
export const J1772 = 'J1772';
export const MENNEKES = 'Mennekes';

const connectorTypes = {
  NO_PLUG: NO_PLUG,
  CCS1: CCS1,
  CCS2: CCS2,
  CHADEMO: CHADEMO,
  TESLA: TESLA,
  GBTDC: GBTDC,
  GBTAC: GBTAC,
  J1772: J1772,
  MENNEKES: MENNEKES,
};

export default connectorTypes;
